import script from "./DownloadPostel.vue?vue&type=script&setup=true&lang=js"
export * from "./DownloadPostel.vue?vue&type=script&setup=true&lang=js"

import "./DownloadPostel.vue?vue&type=style&index=0&id=e7d305c6&lang=css"

const __exports__ = script;

export default __exports__